import { render, staticRenderFns } from "./editInspectionPlan.vue?vue&type=template&id=a96cffc6&scoped=true"
import script from "./editInspectionPlan.vue?vue&type=script&lang=js"
export * from "./editInspectionPlan.vue?vue&type=script&lang=js"
import style0 from "./editInspectionPlan.vue?vue&type=style&index=0&id=a96cffc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96cffc6",
  null
  
)

export default component.exports